import {
  GKButton,
  GKModal,
  GKSearchSelect,
  Grid2,
  Typography,
} from "components";
import { useMutation } from "hooks/useQueries";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import { refetchQuery } from "utils/helpers";

const SelectBenchmarkModal = ({ open, setOpen }: GKModalProps) => {
  const { id } = useParams();

  const { control, handleSubmit } = useForm();

  const companyMasterData = useAppSelector((state) =>
    state.app?.companies?.filter((dataItem) =>
      ["INDEX", "EQ"]?.includes(dataItem?.instType),
    ),
  );

  const [value, setValue] = useState({
    name: "",
    value: "",
    gridCode: "",
    companyName: "",
    instType: "",
    instSubType: "",
    isin: "",
    bse: "",
    nse: "",
    shortName: "",
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: (data: any) =>
      axiosInstance.patch(`/portfolios/${id}/performance_comparision/`, data),
    onSuccess: () => {
      refetchQuery("GET_PORTFOLIO_DETAIL_BY_ID");
      refetchQuery("GET_ALL_BENCHMARK_CHART");
      setOpen(false);
    },
  });

  const onSubmit = (data: any) => {
    mutate({
      benchmark: data.benchmark?.gridCode,
    });
  };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Change Benchmark"
      footer={
        <GKButton
          loading={isLoading}
          variant="contained"
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2 size={12}>
          <Controller
            name="benchmark"
            control={control}
            rules={{ required: "Please select a company" }}
            render={({ field, fieldState: { error } }) => (
              <GKSearchSelect
                {...field}
                inputLabel="Select Company"
                disableClearable
                requiredField
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <Typography
                      color={"var(--white)"}
                      fontSize={8}
                      style={{
                        background:
                          option?.instType === "EQ"
                            ? "var(--secondary-900)"
                            : "var(--orange-700)",
                        padding: "2px 4px",
                        borderRadius: 4,
                      }}
                    >
                      {option?.instType}
                    </Typography>
                    <Typography whiteSpace={"nowrap"}>
                      {option?.name}
                    </Typography>
                  </li>
                )}
                options={
                  companyMasterData?.map((item: any) => ({
                    name: item?.companyName,
                    value: item?.isin,
                    ...item,
                  })) || []
                }
                getOptionLabel={(option) => {
                  return option?.name || option;
                }}
                onChange={(ev, val) => {
                  field.onChange(val);
                  setValue(val);
                }}
                value={value?.name || ""}
                error={!!error}
                helperText={error ? error.message : ""}
              />
            )}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default SelectBenchmarkModal;
